
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetonashikacabs() {



    const cardData =
    {
        keyword: ' Pune to Nashik Cab',
        heading: 'Prince Cabs: Pune to Nashik Cab',
        headingDescription: 'Prince Cabs provides reliable Pune to Nashik Cab services, perfect for pilgrimage tours, family trips, corporate travel, and weekend getaways. Our fleet includes well-maintained sedans, SUVs, and luxury cars, ensuring a safe and comfortable journey to Nashik’s famous temples, vineyards, and scenic spots. With professional chauffeurs, flexible schedules, and on-time pickups, we make your Pune to Nashik travel stress-free and enjoyable. Experience affordability, convenience, and trusted service with Prince Cabs’ dedicated cab service from Pune to Nashik.',

        top: 'Top Places to Visit in Nashik with Prince Cabs',

"topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description": "The Trimbakeshwar Temple, one of the 12 Jyotirlingas of Lord Shiva, is Nashik’s most sacred attraction. Built in black stone in classic Nagara-style architecture, the temple is renowned for its three-faced linga representing Brahma, Vishnu, and Shiva. Pilgrims believe that a visit here cleanses them of sins and fulfills spiritual desires. The temple is also the origin point of the holy Godavari River. Religious rituals like Narayan Nagbali Puja and Kalsarp Dosh Puja are widely performed here. Surrounded by the lush Brahmagiri Hills, the temple exudes divinity and peace."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous winery, located in Nashik’s wine country. Spread across vast scenic landscapes, it offers wine-tasting tours, grape stomping, and luxury stays. Visitors can explore the process of winemaking while sampling premium wines. The vineyard hosts the annual SulaFest, a popular music and wine festival that draws tourists from across the globe. Its vineyards, set against rolling hills, are a delight for photography. Sula is a must-visit for food, wine, and nature lovers looking for a unique experience in Nashik."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a revered pilgrimage site in Nashik, deeply connected to the Ramayana. It is believed that Lord Rama, Sita, and Lakshmana spent part of their exile here. Attractions include Sita Gufa (a small cave temple), Kalaram Temple, and several ghats along the Godavari River. Devotees visit to experience its rich spiritual energy and mythological significance. The area is particularly crowded during the Kumbh Mela, which takes place every 12 years. Panchavati symbolizes devotion, culture, and India’s timeless epics."
  },
  {
    "title": "Pandav Leni Caves",
    "description": "The Pandav Leni Caves, also called Nashik Caves, are a group of 24 rock-cut caves dating back to the 1st–3rd century BC. These ancient Buddhist caves showcase intricate carvings, stupas, and viharas used by monks for meditation. The caves are located on Trivashmi Hill, offering scenic views of Nashik city below. They reflect India’s rich heritage in art and architecture. Visitors enjoy trekking up the hill to explore the caves and admire their craftsmanship. It’s a perfect blend of history, spirituality, and nature."
  },
  {
    "title": "Kalaram Temple",
    "description": "Kalaram Temple is one of the most important Hindu temples in Nashik, dedicated to Lord Rama. Built in 1788 by Sardar Odhekar, the temple is constructed in black stone with an 87-foot tall spire. The idol of Lord Rama inside is also carved in black stone, hence the name ‘Kalaram.’ The temple is surrounded by smaller shrines dedicated to Lakshmana, Sita, and Hanuman. It holds immense historical and cultural value, especially during the Ramnavami festival. It is a major stop for pilgrims visiting Panchavati."
  },
  {
    "title": "Someshwar Waterfalls",
    "description": "Someshwar Waterfalls, also known as Dudhsagar Falls (not to be confused with the one in Goa), is a popular picnic spot near Nashik. The waterfall cascades gracefully amid lush greenery, creating a soothing and refreshing atmosphere. Families and tourists often gather here during monsoon when the falls are at their best. The nearby Someshwar Temple dedicated to Lord Shiva adds spiritual significance. Its serene natural setting makes it ideal for photography and leisure. It’s one of Nashik’s best-loved weekend getaways."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Anjaneri Hills, located near Trimbakeshwar, is believed to be the birthplace of Lord Hanuman. The hills are a popular trekking destination, offering panoramic views of the Sahyadris and Nashik city. The trek passes through lush greenery, waterfalls, and small caves, making it a favorite among nature lovers. Devotees also visit the small Hanuman temple atop the hill. The mix of mythology and adventure makes it a unique attraction. Anjaneri is a perfect spot for both pilgrims and trekkers."
  },
  {
    "title": "Ramkund",
    "description": "Ramkund is a sacred bathing ghat on the banks of the Godavari River in Panchavati, Nashik. It is believed that Lord Rama and Sita bathed here during their exile. Pilgrims take a holy dip in the kund, as it is said to cleanse sins and grant salvation. During Kumbh Mela, millions of devotees gather at Ramkund to perform rituals and offer prayers. The ghat also has memorials dedicated to freedom fighters like Pandit Nehru. Its religious aura makes it one of Nashik’s most visited spiritual sites."
  },
  {
    "title": "Saptashrungi Devi Temple",
    "description": "Located about 60 km from Nashik, Saptashrungi Devi Temple is one of the most revered Shakti Peethas in Maharashtra. Dedicated to Goddess Saptashrungi Nivasini, the temple is perched on a hill with 510 steps leading up to it. Devotees believe that the goddess has manifested here with 18 arms holding various weapons. The temple is especially vibrant during Navratri when thousands of devotees flock here. The views from the temple are breathtaking, overlooking valleys and mountains. It combines faith, adventure, and natural beauty."
  },
  {
    "title": "Muktidham Temple",
    "description": "Muktidham Temple is a modern marble temple in Nashik that houses replicas of all 12 Jyotirlingas, making it a unique pilgrimage site. Built in the 1970s, the temple is made entirely of white marble with intricate carvings. It also has shrines dedicated to various Hindu gods and goddesses, along with inscriptions from the Bhagavad Gita. Visitors experience a sense of spiritual completeness by visiting this temple. Its architecture and peaceful ambiance make it a major attraction in Nashik. It is especially popular among tourists with limited time for travel."
  }
],


"services": [
    {
        "name": "Pune to Nashik Innova Service",
        "description": "Travel comfortably from Pune to Nashik with our Innova service, offering spacious interiors, air conditioning, and professional drivers who ensure a safe and smooth journey. Perfect for families and groups, this service combines luxury with affordability for long-distance travel."
    },
    {
        "name": "Pune to Nashik Taxi Service",
        "description": "Reliable taxi service from Pune to Nashik, available 24/7 with well-maintained vehicles and experienced drivers. Whether it’s a business trip or leisure travel, enjoy punctual pickups and flexible booking options tailored to your convenience."
    },
    {
        "name": "Pune Airport to Nashik Innova Cab",
        "description": "Book your Innova cab from Pune Airport to Nashik for a seamless airport transfer experience. Our drivers monitor your flight timings and ensure timely pickups, so you can start your trip without any delays or hassle."
    },
    {
        "name": "Pune Airport to Nashik Cab",
        "description": "Convenient cab service from Pune Airport to Nashik, featuring a range of vehicle options to suit solo travelers, families, and groups. With professional drivers and transparent pricing, enjoy a comfortable ride to your destination."
    },
    {
        "name": "Pune Airport to Nashik Swift Dzire Cab",
        "description": "Affordable and efficient Swift Dzire cab service from Pune Airport to Nashik. Ideal for small families or business travelers, this sedan offers excellent mileage, AC comfort, and a smooth ride for your journey."
    },
    {
        "name": "Pune to Nashik Cab Service",
        "description": "Comprehensive cab service from Pune to Nashik including one-way and round-trip options. Our vehicles are regularly sanitized and driven by experienced professionals to ensure a safe and pleasant travel experience."
    },
    {
        "name": "Pune to Nashik Taxi",
        "description": "Book a taxi from Pune to Nashik with flexible timings and competitive pricing. Our cabs are perfect for both short and long trips, offering comfort, safety, and punctuality throughout your journey."
    },
    {
        "name": "Pune to Trimbakeshwar Cab",
        "description": "Explore the sacred Trimbakeshwar temple with our dedicated cab service from Pune. Our drivers are knowledgeable about the route and local area, ensuring a smooth journey to this important pilgrimage site."
    },
    {
        "name": "Pune to Trimbakeshwar Cab Fare",
        "description": "Get clear and upfront cab fare estimates for trips from Pune to Trimbakeshwar. Our pricing is all-inclusive covering tolls, driver charges, and taxes, with no hidden fees, making your pilgrimage budget-friendly and hassle-free."
    },
    {
        "name": "Pune to Trimbakeshwar Innova Cab",
        "description": "Travel to Trimbakeshwar in comfort with our Innova cab service from Pune. Spacious interiors and AC comfort make this the perfect choice for families and groups visiting the holy temple."
    },
    {
        "name": "Pune to Nashik Dzire Taxi",
        "description": "Efficient and economical Dzire taxi service from Pune to Nashik. Ideal for couples and small families, this sedan offers a smooth ride with professional drivers familiar with the route."
    },
    {
        "name": "Pune to Nashik Round Trip Cab",
        "description": "Plan your round trip from Pune to Nashik with our flexible cab services. Enjoy the convenience of a single driver and vehicle throughout your journey with options for sightseeing and extended stops."
    },
    {
        "name": "Pune to Nashik Tour Package",
        "description": "Complete tour packages from Pune to Nashik including transportation, driver services, and sightseeing stops. Ideal for travelers looking to explore Nashik’s vineyards, temples, and historical sites with ease."
    },
    {
        "name": "Pune to Nashik Affordable Taxi",
        "description": "Affordable taxi options from Pune to Nashik offering reliable service without compromising comfort or safety. Perfect for budget travelers seeking quality rides with transparent pricing."
    }
],
"tableData": [
    ["Pune to Nashik Innova Service", "Pune to Nashik Taxi Service"],
    ["Pune Airport to Nashik Innova Cab", "Pune Airport to Nashik Cab"],
    ["Pune Airport to Nashik Swift Dzire Cab", "Pune to Nashik Cab Service"],
    ["Pune to Nashik Taxi", "Pune to Trimbakeshwar Cab"],
    ["Pune to Trimbakeshwar Cab Fare", "Pune to Trimbakeshwar Innova Cab"],
    ["Pune to Nashik Dzire Taxi", "Pune to Nashik Round Trip Cab"],
    ["Pune to Nashik Tour Package", "Pune to Nashik Affordable Taxi"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Nashik Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable cab services from Pune to Nashik, perfect for business trips, leisure travel, or religious visits. We ensure punctual pickups and a comfortable journey."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Travel in well-maintained, air-conditioned cabs with ample legroom and luggage space, designed to provide maximum comfort on the Pune to Nashik route."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
        "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Nashik highways and local traffic, ensuring safe driving and timely arrivals."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Needs",
        "WhyChoosedescription": "Prince Cabs offers customizable packages including one-way, round-trip, or multi-day rentals. Book conveniently via phone, website, or WhatsApp to suit your schedule."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Protocols",
        "WhyChoosedescription": "All vehicles are cleaned and sanitized before every trip. We prioritize your health and safety with regular vehicle maintenance and essential safety features."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Methods",
        "WhyChoosedescription": "Enjoy competitive pricing with no hidden charges. Payments are accepted through UPI, credit/debit cards, net banking, and cash for your convenience."
    },
    {
        "WhyChooseheading": "Dedicated Customer Support for Hassle-Free Travel",
        "WhyChoosedescription": "Our customer service team is available 24/7 to assist you throughout your journey, ensuring a smooth and worry-free Pune to Nashik cab experience."
    }
]





















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Nashik cab services?',
        answer: 'Yes, Prince Cabs provides safe and reliable cab services from Pune to Nashik, suitable for business trips, pilgrimages, vineyard tours, and weekend travel.',
    },
    {
        question: 'What types of cabs are available for the Pune to Nashik route?',
        answer: 'We offer a variety of cab options including hatchbacks, sedans, SUVs, and tempo travellers to accommodate individuals, families, and groups.',
    },
    {
        question: 'Is the Pune to Nashik cab ride comfortable for long-distance travel?',
        answer: 'Absolutely! Our cabs are air-conditioned, well-maintained, and driven by experienced chauffeurs to ensure a smooth and relaxing travel experience.',
    },
    {
        question: 'Can I customize the trip itinerary from Pune to Nashik?',
        answer: 'Yes, you can plan your own itinerary with flexible pickup points, drop locations, and optional stopovers like Sula Vineyards or Trimbakeshwar.',
    },
    {
        question: 'What are the cab charges for Pune to Nashik travel?',
        answer: 'The fare depends on the type of vehicle, travel duration, and any custom requirements. Contact Prince Cabs for a transparent and competitive quote.',
    },
    {
        question: 'How do I book a Pune to Nashik cab with Prince Cabs?',
        answer: 'Booking is simple—get in touch with us via phone or our website, provide your travel details, and we’ll recommend the best cab for your needs.',
    },
    {
        question: 'Are your cabs clean and well-maintained for intercity travel?',
        answer: 'Yes, all our cabs are regularly cleaned, sanitized, and serviced to provide a safe, hygienic, and comfortable ride to Nashik.',
    },
];

const testimonials = [
    {
        name: "Mr. Ajay Shukla",
        position: "Corporate Traveler",
        text: "I booked a Pune to Nashik cab with Prince Cabs for a business meeting. The car was on time, the driver was professional, and the ride was smooth.",
        image: "/img/testimonial/testimonial-thumb-nashik-1.png",
    },
    {
        name: "Ms. Pooja Kulkarni",
        position: "Wine Enthusiast",
        text: "Our trip from Pune to Nashik was amazing. We visited the vineyards and had a great time—all thanks to the punctual and courteous service from Prince Cabs.",
        image: "/img/testimonial/testimonial-thumb-nashik-2.png",
    },
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Cab",
  "image": "https://princecab.com/assets/images/pune-nashik-cab.jpg",
  "description": "Book Pune to Nashik cab with Prince Cabs – Reliable and affordable taxi options including Dzire, Etios, Innova Crysta, and SUVs. Ideal for Nashik and Trimbakeshwar trips. Airport pickup and round trip services available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "6930"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-nashik-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Nashik Cab | Trimbakeshwar Tour & Airport Pickup | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs provides Pune to Nashik taxi services with well-maintained Dzire, Etios, and Innova vehicles. Book one-way, round trip, or Trimbakeshwar darshan cabs with 24/7 support and affordable fares."
  />
  <meta
    name="keywords"
    content="Pune to Nashik Innova Service, Pune to Nashik Taxi Service, Pune Airport to Nashik Innova Cab, Pune Airport to Nashik Cab, Pune Airport to Nashik Swift Dzire Cab, Pune to Nashik Cab Service, Pune to Nashik Taxi, Pune to Trimbakeshwar Cab, Pune to Trimbakeshwar Cab Fare, Pune to Trimbakeshwar Innova Cab, Pune to Nashik Dzire Taxi, Pune to Nashik Round Trip Cab, Pune to Nashik Tour Package, Pune to Nashik Affordable Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/7.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonashikacabs;